import { ProductAction } from "features/product/types/actions.product";
import { ProductTable } from "features/product/types/subproductTable";
import firebase from "firebase/app";
import "firebase/firestore";

import { AppThunk } from "services/redux/rootReducer";
import { Product } from "../../types/product";

const getProductsWithTables =
    (ids: Product["id"][]): AppThunk<Promise<void>> =>
    async (dispatch, getState) => {
        const db = firebase.firestore();
        const collectionRef = db.collection("products");

        // Remove products with ids in the array so they can be updated
        let unselectedProducts: Product[] = getState().products.filter(
            (product) => !ids.includes(product.id)
        );
        let selectedProducts: Product[] = [];

        // Get the products from given ids
        await Promise.all(
            ids.map(async (id) => {
                const product = (
                    await collectionRef.doc(id).get()
                ).data() as Product;
                const subCollectionRef = collectionRef
                    .doc(product.id)
                    .collection("tables");

                const tableSnapshot = await subCollectionRef.get();

                let tables: Record<string, ProductTable> = {};
                tableSnapshot.docs
                    .filter((tableDoc) =>
                        product.tableIds.includes(tableDoc.data().id)
                    )
                    .forEach((tableDoc) => {
                        const table = tableDoc.data() as ProductTable;
                        tables[table.id] = table;
                    });

                // inject them into the products array
                selectedProducts.push({
                    ...product,
                    tables,
                });
            })
        );

        dispatch({
            type: ProductAction.SET_PRODUCTS,
            products: [...unselectedProducts, ...selectedProducts],
        });
        return;
    };

export default getProductsWithTables;
